import { EnqueueSnackbar } from 'notistack'

import Api from '../../utils/api'

const sendPasscode = async (values: ILoginFormValues, onLogin: () => void, enqueueSnackbar: EnqueueSnackbar) => {
  const { email, phone } = values

  const res = await Api.post('/api/v2/onetimerequest', { login: email || phone })
  if (res.ok) {
    onLogin()
  } else enqueueSnackbar('An error occurred.', { variant: 'error' })
}

export default sendPasscode
